'use strict';

rentalProduct.$inject = ["RentalProductOverviewItem"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProduct = rentalProduct;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProduct(RentalProductOverviewItem) {
    var clazz = function RentalProduct() {
        var defaults = {
            id: 0,
            relationTypeCode: null,
            name: '',
            nationalNumber: null,
            sellerName: '',
            sellerId: 0,
            sellerBaseCodeId: 0,
            imagePath: '',
            rentalDeposit: 0,
            dayPrice: 0,
            vat: 0,
            deliveryDate: null,
            remark: null,
            address: null,
            contractPerson: null,
            phoneNumber: null,
            isSellable: false,
            quantity: 0,
            relatedRentalProducts: [],
            attachments: [],
            pharmacyPrice: 0,
            publicPrice: 0,
            deliveryByExternalPartner: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        toJSON: function toJSON() {
            return {
                productId: this.id,
                quantity: this.quantity
            };
        }
    });

    clazz.create = function (resource) {
        var product = new clazz();
        product.id = resource.productId;
        product.relationTypeCode = resource.relationTypeCode;
        product.name = resource.productName;
        product.nationalNumber = resource.nationalNumber;
        product.sellerName = resource.sellerName;
        product.sellerId = resource.sellerId;
        product.sellerBaseCodeId = resource.sellerBaseCodeId;
        product.imagePath = resource.imagePath;
        product.rentalDeposit = resource.rentalDeposit;
        product.dayPrice = resource.dayPrice;
        product.vat = resource.vat;
        product.deliveryDate = resource.deliveryDate;
        product.remark = resource.remark;
        product.address = resource.address;
        product.contractPerson = resource.contractPerson;
        product.phoneNumber = resource.phoneNumber;
        product.isSellable = resource.isSellable;
        product.quantity = 1;
        product.relatedRentalProducts = _lodash2.default.map(resource.relatedRentalProducts, function (i) {
            return RentalProductOverviewItem.create(i);
        });
        product.attachments = resource.productRentalAttachments;
        product.pharmacyPrice = resource.pharmacyPrice;
        product.publicPrice = resource.publicPrice;
        product.deliveryByExternalPartner = resource.deliveryByExternalPartner;
        return product;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/rentalProductModel.js
// module id = 784
// module chunks = 0